// extracted by mini-css-extract-plugin
module.exports = {"balance_wrapper":"dd31006766--balance_wrapper--GagLT"};